import Icon from '../components/Icon.vue'

Icon.register({"tape":{"width":640,"height":512,"paths":[{"d":"M224 192C188.7 192 160 220.7 160 256S188.7 320 224 320 288 291.3 288 256 259.3 192 224 192zM624 416H380.6C422.1 375.3 448 318.7 448 256 448 132.3 347.7 32 224 32S0 132.3 0 256 100.3 480 224 480H624C632.8 480 640 472.8 640 464V432C640 423.2 632.8 416 624 416zM224 352C171 352 128 309 128 256S171 160 224 160 320 203 320 256 277 352 224 352z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tape.js
// module id = FISF
// module chunks = 0